export default "__VITE_ASSET__NAnK14pw__"